import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
  loadingGroup: boolean;
  loadingCourse: boolean;
  loadingSemester: boolean;
  loadingCurricularUnit: boolean;
}

const initialState: LoadingState = {
  loadingGroup: false,
  loadingCourse: false,
  loadingSemester: false,
  loadingCurricularUnit: false,
};

export const LoadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoadingCourse: (state, action: PayloadAction<boolean>) => {
      state.loadingCourse = action.payload;
    },
    setLoadingSemester: (state, action: PayloadAction<boolean>) => {
      state.loadingSemester = action.payload;
    },
    setLoadingCurricularUnit: (state, action: PayloadAction<boolean>) => {
      state.loadingCurricularUnit = action.payload;
    },
    setLoadingGroup: (state, action: PayloadAction<boolean>) => {
      state.loadingGroup = action.payload;
    },
  },
});

export const {
  setLoadingCourse,
  setLoadingSemester,
  setLoadingCurricularUnit,
  setLoadingGroup,
} = LoadingSlice.actions;
export default LoadingSlice.reducer;
